import { marks as basicMarks } from "prosemirror-schema-basic";
export function italicMarkSpec() {
    return {
        em: basicMarks.em,
    };
}
